module.exports = __webpack_public_path__ + "static/icon_stratz-43c6438802fb648fbd17db30b111919f.png";